import { generateQueryString } from '../../common/base/report/report-util';

/*
  Selected ids vs. the full lists on screen. "All" is decided by what is on screen, not by the
  length of the selection, so ids left over from another fiscal year never count as "all".
*/
export const buildFundBankFilter = ({
  funds, banks, fundList, bankList,
}) => ({
  funds,
  banks,
  allFunds: (fundList || []).every((f) => (funds || []).includes(f._id)),
  allBanks: (bankList || []).every((b) => (banks || []).includes(b._id)),
});

/*
  `fundBankFilter` is only passed by reports that let the user pick funds/banks. The `all*` flags
  let the backend skip the filter entirely; the id lists are only meaningful when a flag is false
  (an empty list then means "none selected").
*/
export const queryStringCalc = ({
  criteria,
  token,
  fundBankFilter,
}) => {
  const params = [];
  if (fundBankFilter) {
    const {
      funds, banks, allFunds, allBanks,
    } = fundBankFilter;
    params.push(`allFunds=${allFunds}`);
    params.push(`allBanks=${allBanks}`);
    if (!allFunds) {
      params.push(`funds=${(funds || []).join(',')}`);
    }
    if (!allBanks) {
      params.push(`banks=${(banks || []).join(',')}`);
    }
  }
  if (criteria.fiscalYear) {
    params.push(`fiscalYear=${criteria.fiscalYear}`);
  }

  if (criteria.fromDate) {
    params.push(`fromDate=${criteria.fromDate}`);
  }

  if (criteria.toDate) {
    params.push(`toDate=${criteria.toDate}`);
  }

  if (criteria.isIncludeJournalEntries) {
    params.push(`isIncludeJournalEntries=${criteria.isIncludeJournalEntries}`);
  }
  if (criteria.isIncludeTransfers) {
    params.push(`isIncludeTransfers=${criteria.isIncludeTransfers}`);
  }
  if (criteria.isComments) {
    params.push(`isComments=${criteria.isComments}`);
  }
  if (criteria.isPrintSubledgers) {
    params.push(`isPrintSubledgers=${criteria.isPrintSubledgers}`);
  }

  if (criteria.isIncludeApportionment) {
    params.push(`isIncludeApportionment=${criteria.isIncludeApportionment}`);
  }

  if (criteria.isPrintTotals) {
    params.push(`isPrintTotals=${criteria.isPrintTotals}`);
  }

  if (criteria.isPrintAllLines) {
    params.push(`isPrintAllLines=${criteria.isPrintAllLines}`);
  }
  if (criteria.isAllDetails) {
    params.push(`isAllDetails=${criteria.isAllDetails}`);
  }

  if (criteria.singleLineFundWithDetail) {
    params.push(`singleLineFundWithDetail=${criteria.singleLineFundWithDetail}`);
  }
  if (criteria.singleLineBankWithDetail) {
    params.push(`singleLineBankWithDetail=${criteria.singleLineBankWithDetail}`);
  }

  if (token) {
    params.push(`token=${token}`);
  }
  return generateQueryString(params);
};
export const queryStringForTaxLeavies = ({
  criteria,
  token,
}) => {
  const params = [];
  if (criteria.taxYear) {
    params.push(`taxYear=${criteria.taxYear}`);
  }

  if (criteria.taxDistrict) {
    params.push(`taxDistrict=${criteria.taxDistrict}`);
  }

  if (token) {
    params.push(`token=${token}`);
  }
  return generateQueryString(params);
};

export const queryStringCalcForDailyGL = ({
  criteria,
  token,
}) => {
  const params = [];
  if (criteria.fiscalYear) {
    params.push(`fiscalYear=${criteria.fiscalYear}`);
  }

  if (criteria.businessDate) {
    params.push(`businessDate=${criteria.businessDate}`);
  }

  if (token) {
    params.push(`token=${token}`);
  }
  return generateQueryString(params);
};
export const queryStringCollateralGL = ({
  criteria,
  token,
}) => {
  const params = [];
  if (criteria.fiscalYear) {
    params.push(`fiscalYear=${criteria.fiscalYear}`);
  }

  if (criteria.toDate) {
    params.push(`toDate=${criteria.toDate}`);
  }

  if (token) {
    params.push(`token=${token}`);
  }
  return generateQueryString(params);
};

export default {
  queryStringCalc,
};
